import { render, staticRenderFns } from "./LahanUmum.vue?vue&type=template&id=37b025d0"
import script from "./LahanUmum.vue?vue&type=script&lang=js"
export * from "./LahanUmum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports